import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { Handle, Position, type NodeProps } from "@xyflow/react";
import type { ResolverFlowNode } from "./utils";

const ResolverFlowCard: React.FC<NodeProps<ResolverFlowNode>> = ({ data, selected }) => (
    <Box sx={{ position: "relative", width: 240 }}>
        <Handle type="target" position={Position.Left} style={{ left: 0, top: "50%" }} />
        <Paper
            variant="outlined"
            sx={{
                width: 240,
                p: 1.25,
                borderColor: selected ? "primary.main" : "#B8C1CC",
                boxShadow: selected ? 3 : 1,
                bgcolor: "#FFFFFF",
            }}
        >
            <Typography variant="subtitle2" noWrap>
                {data.label}
            </Typography>
        </Paper>
        <Handle type="source" position={Position.Right} style={{ right: 0, top: "50%" }} />
    </Box>
);

export { ResolverFlowCard };
